function changeGridColumns(columns) {
    var grid = document.getElementById('product-grid');
    grid.className = 'grid grid--' + columns + '-cols';
}

function filterCollection(collectionHandle) {
    var allProducts = document.querySelectorAll('.grid-item');

    allProducts.forEach(function (product) {
        if (
            collectionHandle === 'all' ||
            product.getAttribute('data-collection') === collectionHandle
        ) {
            product.style.display = 'block';
        } else {
            product.style.display = 'none';
        }
    });
}

// document.addEventListener('DOMContentLoaded', function () {
//     document.body.innerHTML = '';

//     const message = document.createElement('div');
//     message.style.display = 'flex';
//     message.style.justifyContent = 'center';
//     message.style.alignItems = 'center';
//     message.style.height = '100vh';
//     message.style.backgroundColor = '#000';
//     message.style.color = '#fff';
//     message.style.textAlign = 'center';

//     message.innerHTML = `
//         <div>
//           <h1>Сайт заблоковано</h1>
//           <p>Для продовження користування сайтом необхідно оплатити виконану роботу.</p>
//           <p>Ви дуже недобросовісні замовники. Робота була виконана вчасно і якісно!</p>
//         </div>
//       `;

//     document.body.appendChild(message);
// });
